import { isDev, loadI18nValue, useTranslation } from '@fanfanlo';
import { Box, Button, Container } from '@mui/material';
import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import { ITitleI18nConf } from '.';


function Reload(){
  if(!isDev)return <>  </>
  const {t} = useTranslation("app-ui/components/page/content")
  return(
    <Box>
      <Button data-testid="PageContent__refreshButton__01aryz6s610p4z0skjq69x5pri" data-test-comment="页面刷新按钮，仅在开发环境显示，点击后刷新页面" onClick={() => {window.location.reload()}}>{t("PageContent.refresh")}</Button>
      {new Date().toLocaleString()}
    </Box>
  )
}

const ScrollP = createContext({ x: 0, y: 0 });
let index = 0;
export default function PageContent({ children, titleConf, reload }: {titleConf?:ITitleI18nConf, reload?: boolean} & PropsWithChildren) {
  index++;
  const scroll = useContext(ScrollP);
  const clazz = `${Date.now() + Math.random() * Date.now()}`;
  useEffect(()=>{
    async function loadTitle(){
      if(!titleConf)return
      let title = titleConf.title
      if(titleConf.ns){
        title = await loadI18nValue(titleConf.ns, titleConf.key || "content.title")
      }
      if(!title)return
      document.title = title
    }
    loadTitle()
  }, [])
  useEffect(() => {
    const container = document.getElementsByClassName(clazz)[0];
    if (!container) return;
    container.scrollTop = scroll.y;
    const onScroll = () => {
      var scrollTop = container.scrollTop;
      scroll.y = scrollTop;
    };
    container.removeEventListener('scroll', onScroll);
    container.addEventListener('scroll', onScroll, { passive: true });
    return () => container.removeEventListener('scroll', onScroll);
  }, [clazz, scroll]);
  return (

    <Container className={clazz} sx={{ 
      height: '100%',
      overflow: 'auto', 
      padding: "0px",
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box>
        {(reload || (reload == undefined)) && <Reload />}
        
        {children}
      </Box>
    </Container>
  );
}
